import FormPrototype from '@/models/FormPrototype';

export default class ValidateLenses
{
    /**
     * Vue Object
     */
    v = null;

    constructor(v)
    {
        this.v = v;
    }

    async handle()
    {
        const requests = {};
        const options  = {};
        const eid      = this.v.$store.state.account.cEntity.id;
        const viewAs   = this.v.$store.state.lensOrder.viewAs;

        // Set overlay text
        this.v.$store.commit('overlay/setText', this.v.$t('overlay.validating'));

        // Validate each side
        for(const side of ['right', 'left'])
        {
            /** @type {?FormPrototype} */
            const proto = this.v.$store.getters['lensOrder/getPrototype'](side);
            if(proto)
            {
                console.log(`Validate ${side} side`);
                requests[side] = proto.templateAndValidate(eid, options, viewAs);
            }
        }

        try
        {
            const responses = await this.allNamed(requests);
            for(const side in responses)
            {
                const { data } = responses[side];
                if(!data)
                {
                    throw new Error(`${side}: missing response data`);
                }

                const validation = data?.validation;
                if(validation !== null)
                {
                    console.log(`${side} lens validation error:`, validation);
                    throw validation;
                }

                console.log(`${side} lens validation OK!`);
            }

            return true;
        }
        catch(error)
        {
            console.log('Lens validation error:', error);
            throw error;
        }
    }

    /**
     * Same as `Promise.all()`, but with the list of promises as key-value pairs
     * instead of an array.
     *
     * @param {Record<string, Promise>} promises
     * @returns {Record<string, any>}
     */
    async allNamed(promises)
    {
        const type = typeof promises;
        if(type !== 'object')
        {
            throw new TypeError(`promises must be an object, ${type} given`);
        }

        const entries = Object.entries(promises);
        const results = await Promise.all(entries.map(([_, p]) => p));
        return Object.fromEntries(entries.map(([k], i) => [k, results[i]]));
    }
}
